module.exports = __webpack_public_path__ + "img/49.11506415.png";